import Div from "theme/layouts/Div";
import PropTypes from "prop-types";
import React from "react";
import TextStyles from "theme/components/text/TextStyles";
import Wysiwyg from "theme/libs/wordpress/components/Wysiwyg";
import variables from "theme/config/variables";

const Heading = ({ data, isCustomerService }) => (
    <Div mb="40px">
        {/* We place the anchor_link above the actual content, otherwise the content will go behind the header bar when scrolled to. */}
        {data?.anchor_link && (
            <Div
                id={data?.anchor_link}
                position="absolute"
                top={[
                    `calc(-${variables.headerHeightMobile}px - 16px)`,
                    null,
                    null,
                    null,
                    `calc(-${variables.headerHeightDesktop}px - 24px)`,
                ]}
            />
        )}
        <Wysiwyg
            data={data.text}
            textComponent={(props) => (
                <TextStyles
                    as={data.type === "default" ? "h2" : data.type}
                    textStyles={[
                        "Myriad Pro/40-120-semibold",
                        null,
                        null,
                        null,
                        isCustomerService ? "Myriad Pro/48-120-semibold" : "Myriad Pro/64-110-semibold",
                    ]}
                    {...props}
                />
            )}
        />
    </Div>
);

Heading.propTypes = {
    data: PropTypes.object,
    isCustomerService: PropTypes.bool,
};

Heading.defaultProps = {
    data: {},
    isCustomerService: false,
};

export default Heading;
